import React from 'react';
import PropTypes from 'prop-types';
import { I18n } from 'react-redux-i18n';
import { Icon } from 'front-onceforall-core';
import UserMenu from './userMenu';
import appConfig from '../../../../config';
import { pathResolver } from '../../../utils/basePathHelper';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const menuIconContainerStyle = {
  background: 'rgba(245, 245, 245, 1)',
  padding: '10px',
  borderRadius: '10px',
  height: '40px',
  width: '40px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
};
export const GlobalHeaderView = props => {
  return /*#__PURE__*/_jsxs("div", {
    className: "global-bar",
    children: [/*#__PURE__*/_jsx("button", {
      "data-id": "button-home",
      type: "button",
      className: "button-square",
      onClick: props.onLogoClick,
      title: I18n.t(props.isGoBack ? 'action.back' : 'menu.home'),
      children: appConfig.isMicrofront ? /*#__PURE__*/_jsx("div", {
        style: menuIconContainerStyle,
        children: /*#__PURE__*/_jsx("img", {
          className: "home-button-icon",
          src: `${pathResolver('resources/svg/panda.svg')}`,
          alt: "panda logo home",
          width: "28"
        })
      }) : /*#__PURE__*/_jsx(Icon, {
        icon: props.isGoBack ? 'go-back' : 'home'
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "flex-container column",
      children: [props.newsUrl && /*#__PURE__*/_jsx("button", {
        type: "button",
        "data-id": "news",
        className: "button-square",
        onClick: () => window.open(props.newsUrl),
        title: I18n.t('menu.news'),
        children: /*#__PURE__*/_jsx(Icon, {
          icon: "newspaper"
        })
      }), /*#__PURE__*/_jsx(UserMenu, {})]
    })]
  });
};
GlobalHeaderView.propTypes = {
  onLogoClick: PropTypes.func.isRequired,
  isGoBack: PropTypes.bool,
  newsUrl: PropTypes.string
};
export default GlobalHeaderView;